import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { RoleService } from 'src/app/services/core/role/role.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';

@UntilDestroy()

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {
  companies: any
  users: any;
  search: any = '';
  selectedStatus: any = true;
  filteredUsersList: any;
  preCompanies:any;
  selectedCompany:any = '';
  selectedFundingSource:any = '';
  filteredCompanyList:any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  status = true
  preFundingSource: any = {};
  preMembers: any = {};
  preRoles: any = {};
  isInfo = false;
  fundingSourceList: any;
  userPermission = UserPermission;
  filteredAssociationList: any;
  private searchSubject = new Subject<string>();
  userModalObj: any;
  selectedTab = 'all'
  types:any;


  roles:any;


  constructor(
    private userService: UserService,
    private credentialService: CredentialService,
    private roleService : RoleService,
    private fundingSource: FundingSourceService,
    private memberService: MemberService,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.getCompanies();
    this.getFundingSource();
    this.getAllMembers();
    this.getRoles();
    this.initializeSearch();
    this.getAllUsers(this.currentPage);
    this.getAllTypes();

  }

  getAllUsers(page: number) {
    let queryParams: any = {
      limit: 50,
      sortBy: 'createdAt:desc',
      isActive: this.status,
      company: this.selectedCompany,
      fundingsource: this.selectedFundingSource,
      page,
    }

    if (this.selectedTab !== 'all') {
    queryParams.role = this.selectedTab;
  }

    if (!this.selectedCompany) {
      delete queryParams.company;
    }
    if (!this.selectedFundingSource) {
      delete queryParams.fundingsource;
    }
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryParams.search = trimmedSearch;
    }
    this.userService.getUsers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.users = data.results;
        // this.users = data.results.sort((a: any, b: any) =>
        //   new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        // );
        this.filteredUsersList = [...this.users];
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
        // this.filterUsers();
      }
    })
  }

  getCompanies() {
    const queryparams = {
      limit: 9999,
      isActive: true,
      isApproved: true
    }
    this.credentialService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.companies = data.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  getFundingSource() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSource.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.fundingSourceList = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
        this.preFundingSource = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getAllMembers() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.memberService.getPickerMembers(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.preMembers = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getRoles() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.roleService.getPickerRoles(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.roles = data.results
          this.preRoles = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  openCloseInfo() {
    this.isInfo = !this.isInfo;
  }

  // filterUsers() {
  //   this.filteredUsersList = this.users.filter((user: any) => {

  //     const userCompanyId = user.company?.id || user.company || null;
  //     const selectedCompanyId = this.selectedCompany?.id || null;
  //     const userFundingSourceId = user.fundingsource?.id || user.fundingsource || null;
  //     const selectedFundingId = this.selectedFundingSource?.id || null;

  //     const matchCompany = selectedCompanyId ? userCompanyId === selectedCompanyId : true;
  //     const matchFundingSource = selectedFundingId ? userFundingSourceId === selectedFundingId : true;
  //     const matchStatus = this.selectedStatus !== undefined ? user.isActive === this.selectedStatus : true;
  //     return matchCompany && matchFundingSource && matchStatus;
  //   });
  // }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllUsers(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  onSelectStatus() {
    this.status = this.selectedStatus;
    this.getAllUsers(this.currentPage = 1);
  }

  onCompanyChange() {
    this.selectedFundingSource = '';
    this.getAllUsers(this.currentPage = 1);
  }
  onFundingSourceChange() {
    this.selectedCompany = '';
    this.getAllUsers(this.currentPage = 1);
  }

  // filterFundingsourceBySelection() {
  //   this.selectedCompany = null;
  //   this.filterUsers();
  // }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllUsers(page);
  }

  openUsereModal(user: any) {
    this.userModalObj = user;
  }

  onCloseUserModal() {
    this.userModalObj = null;
  }

  onSave(evt: any) {
    if (!evt) return;

    const idx = this.users.findIndex((u:any) => u.id === evt.id);
    if (idx === -1) return;

    // Merge updated user with associations
    const merged = {
      ...this.users[idx],
      ...evt,
      role: this.preRoles[evt.role] || null,
      company: this.preCompanies[evt.company] || null,
      fundingsource: this.preFundingSource[evt.fundingsource] || null,
      member: this.preMembers[evt.member] || null
    };

    // Update in place or remove depending on status
    if (this.selectedStatus === merged.isActive) {
      this.users[idx] = merged;            // update in place
    } else {
      this.users.splice(idx, 1);           // remove if status changed
    }

    // Update filtered list (for search/filter)
    this.filteredUsersList = [...this.users];

    this.onCloseUserModal();
  }

  getAllTypes() {
    this.roleService.getTypes().pipe(untilDestroyed(this)).subscribe(
      (data: any) => {
        if (data) {
          const showTabs = ["broker", "company", "member", "fundingsource"];
          this.types = data.filter((t: string) => showTabs.includes(t));
          this.types.unshift('all')
        }
      },
      (err) => {
        const errorMessage = err || 'An unexpected error occurred.';
        sweetAlert('Error', errorMessage, 'warning', 'OK');
      }

    );
  }

 applyFilter(type: string) {
  this.selectedTab = type;

  this.clearFilter();
  
  this.currentPage = 1; 

  this.getAllUsers(this.currentPage);
}

clearFilter(){
  this.selectedCompany = '';
  this.selectedFundingSource = ''
}
}
